import { Outlet } from "react-router-dom";
import UserForm from "./UserForm";
import UserList from "./UserList";

export const usersRoutes = [
  {
    path: "users",
    element: Outlet,
    children: [
      {
        path: "",
        element: UserList,
      },
      {
        path: "add",
        element: UserForm,
      },
      {
        path: "edit/:id",
        element: UserForm,
      },
    ],
  },
];
